<div class="card">
  <div class="card-body text-center">
    <div class="align-center">
      <a href="/login" routerLink="/login">
        <img src="assets/images/logo-skuba.png" alt="{{'SKUBA_LOGO'| translate}}" class="home-logo form-logo">
      </a>
    </div>
    <h2>{{'FORGOT_RESET' | translate}}</h2>
    <form class="forgot-password-form"
          (ngSubmit)="submit(passwordResetForm)"
          [formGroup]="passwordResetForm"
          novalidate
          #formDir="ngForm">
      <app-input
        formControlName="new_password1"
        placeholder="NEW_PASSWORD"
        label="NEW_PASSWORD"
        type="password"
        [focus]="true">
        <app-input-validation
          className="error"
          message="REQUIRED"
          [condition]="(passwordResetForm.get('new_password1').touched || formDir.submitted) && passwordResetForm.get('new_password1').hasError('required')">
        </app-input-validation>
        <app-input-validation
          className="error"
          message="PASS_TOO_WEAK"
          [condition]="(passwordResetForm.get('new_password1').touched || formDir.submitted) && hasPasswordDetailError">
        </app-input-validation>
      </app-input>

      <div
        class="password-error-details"
        *ngIf="(passwordResetForm.get('new_password1').touched || formDir.submitted) && hasPasswordDetailError">
        <div *ngIf="passwordResetForm.get('new_password1').hasError('PASS_MIN_LEN_10')">
          {{ 'PASS_MIN_LEN_10' | translate }}
        </div>
        <div *ngIf="passwordResetForm.get('new_password1').hasError('PASS_COMPLEXITY_REQUIRED')">
          {{ 'PASS_COMPLEXITY_REQUIRED' | translate }}
        </div>
        <div *ngIf="passwordResetForm.get('new_password1').hasError('PASS_TOO_COMMON')">
          {{ 'PASS_REQUIREMENTS_HINT' | translate }}
        </div>
        <div *ngIf="passwordResetForm.get('new_password1').hasError('PASS_MATCHES_USERNAME')">
          {{ 'PASS_MATCHES_USERNAME' | translate }}
        </div>
      </div>

      <nz-spin *ngIf="passCheckLoading" nzSimple></nz-spin>
      <app-input formControlName="new_password2"
                 placeholder="REPEAT_PASSWORD"
                 label="REPEAT_PASSWORD"
                 type="password">
        <app-input-validation
          className="error"
          message="REQUIRED"
          [condition]="(passwordResetForm.get('new_password2').touched || formDir.submitted) && passwordResetForm.get('new_password2').hasError('required')">
        </app-input-validation>
        <app-input-validation
          className="error"
          message="PASSWORD_NOT_MATCH"
          [condition]="passwordResetForm.controls['new_password2'].errors?.MatchPassword">
        </app-input-validation>
      </app-input>

      <nz-alert
        *ngIf="errorMessage"
        nzType="error"
        [nzMessage]="errorMessage"
        nzShowIcon
        nzCloseable
        (nzOnClose)="errorMessage = ''"
      ></nz-alert>
      <br/>
      <div class="form-group align-center">
        <app-button [className]="'btn-red'" text="CONFIRM"></app-button>
      </div>
    </form>
  </div>
</div>
